module.exports = __webpack_public_path__ + "static/media/docs-updates.18c2a4ef.png";